module.exports = __webpack_public_path__ + "assets/bronze.1530a0b9.svg";